'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './bulletin-show.routes';

export class BulletinShowComponent {
  constructor($stateParams, BulletinService, $state, Auth, dialogs, $uibModal, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.bulletinId = $stateParams.id;
    this.$uibModal = $uibModal;

    this.isAdmin = Auth.isAdminSync;
    this.user = Auth.getCurrentUserSync();

    this.BulletinService = BulletinService;
    this.$state = $state;
    this.dialogs = dialogs;

    var METHOD = (this.public || this.property) ? "getPublic" : "get";

    this.BulletinService[METHOD]({id: this.bulletinId}, bulletin => {
      this.bulletin = bulletin;
    }, err => {
      console.log('Could not get the bulletin board post from the server.');
    });
  }

  permission() {
    if (!this.public) {
      return true;
    } else {
      return this.bulletin.isPublic;
    }
  }

  underReview() {
    return this.bulletin && this.bulletin.reviewMeta && this.bulletin.reviewMeta.underReview;
  }

  rejectedReview() {
    return this.bulletin && this.bulletin.reviewMeta && this.bulletin.reviewMeta.rejected;
  }

  acceptReview() {
    this.BulletinService.review({
      _id: this.bulletin._id,
      accepted:true,
      meta: {
        creationUser: this.user._id
      }
    }, bulletin => {
      this.bulletin = bulletin
    })
  }

  openReasonModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'reasonForm',
      resolve: {}
    });

    modalInstance.result.then(
      function (reason) {

        that.BulletinService.review({
          _id: that.bulletin._id,
          rejected:true,
          reason: reason,
          meta: {
            creationUser: that.user._id
          }
        }, bulletin => {
          that.bulletin = bulletin
        });

      },
      function () {
      }
    );
  }

  delete() {
    var that = this;

    var dlg = this.dialogs.confirm("Delete Bulletin Board Post?", "Do you really want to delete this post?");
    dlg.result.then(() => {
      // OK delete it
      that.BulletinService.delete({id: that.bulletinId},
        () => {
          that.$state.go("bulletin-list");
        },
        err => {
          alert("Could not delete bulletin board post");
        });
    }, () => {
      // Cancel
    });
  }
}

export default angular.module('conduuApp.bulletinShow', [uiRouter])
  .config(routes)
  .component('bulletinShow', {
    template: require('./bulletin-show.html'),
    controller: BulletinShowComponent,
    controllerAs: 'ctrl',
    bindings: {
      public: '<',
      property: '<',
      realtor: '<',
      url: '@'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/bulletin/show/bulletin-show.component.js